module.exports = "/assets/a70678be6c693f8a9915bec2fa49ee49.svg";